import { render, staticRenderFns } from "./tiles.vue?vue&type=template&id=64cf25db&scoped=true&"
import script from "./tiles.vue?vue&type=script&lang=js&"
export * from "./tiles.vue?vue&type=script&lang=js&"
import style0 from "./tiles.vue?vue&type=style&index=0&id=64cf25db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf25db",
  null
  
)

export default component.exports